// extracted by mini-css-extract-plugin
module.exports = {"carouselDisabled":"PeopleStories_carouselDisabled__ORk7G","carouselArrow":"PeopleStories_carouselArrow__Z6wGr","carouselButtonGroup":"PeopleStories_carouselButtonGroup__4CaAU"};